import { createAction } from "redux-actions";
import * as NotificationsApi from "../api/notifications";
import {
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_FAILURE,
} from "../constants/actionTypes";

const getNotificationsSuccess = createAction(GET_NOTIFICATIONS_SUCCESS);
const getNotificationsFailure = createAction(GET_NOTIFICATIONS_FAILURE);

export function getNotifications() {
  return (dispatch) =>
    NotificationsApi.getUnreadNotifications()
      .then((response) => {
        // Assuming the API returns the list of notifications in data
        dispatch(getNotificationsSuccess(response.data));
      })
      .catch((error) => dispatch(getNotificationsFailure(error)));
}

const markNotificationReadSuccess = createAction(
  MARK_NOTIFICATION_READ_SUCCESS
);
const markNotificationReadFailure = createAction(
  MARK_NOTIFICATION_READ_FAILURE
);

export function markNotificationRead(id) {
  return (dispatch) =>
    NotificationsApi.markNotificationRead(id)
      .then(() => {
        dispatch(markNotificationReadSuccess(id));
      })
      .catch((error) => dispatch(markNotificationReadFailure(error)));
}
